export default {
    control: (base) => ({
        ...base,
        minHeight: 23,
        height: 23,
        width: '13em',
        fontSize: 11
    }),
    indicatorsContainer:
        (base) => ({
            ...base,
            height: 20
        }),
    valueContainer:
        (provided, state) => ({
            ...provided,
            height: '23px',
            padding: '0 0 0 2px'
        }),
    singleValue:
        (provided, state) => ({
            ...provided,
            marginLeft: '1px',
            marginRight: '1px'
        }),
    menu:
        (provided, state) => ({
            ...provided,
            width: '20em',
            zIndex: 10

        }),
    input:
        (provided, state) => ({
            ...provided,
            margin: '0px',
            padding: 0
        }),
    dropdownIndicator:
        (base) => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
            width: '12px'
        }),
    indicatorSeparator:
        (base) => ({
            ...base,
            display: 'none'
        }),
    clearIndicator:
        (base) => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
        }),
    option:
        (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? '#ecf' : base.backgroundColor,
            color: 'black'
        }),

}